export const publicHoliday2025 = {
  cny2025: {
    startDate: '2025/1/29',
    endDate: '2025/1/31',
    label: 'Chinese New Year',
  },
  jhrSultan2025: {
    startDate: '2025/3/23',
    endDate: '2025/3/23',
    label: 'Birthday of Sultan Johor (Johor Only)',
  },
  jhrSultan2025replacement: {
    startDate: '2025/3/24',
    endDate: '2025/3/24',
    label: 'Birthday of Sultan Johor (Johor Only) [Replacement]',
  },
  rayaAidilfitri2025: {
    startDate: '2025/3/31',
    endDate: '2025/4/1',
    label: 'Hari Raya Aidilfitri',
  },
  labour2025: {
    startDate: '2025/5/1',
    endDate: '2025/5/1',
    label: 'Labour Day',
  },
  agongBday2025: {
    startDate: '2025/6/2',
    endDate: '2025/6/2',
    label: 'Birthday of Yang di-Pertuan Agong',
  },
  pnGovBday2025: {
    startDate: '2025/7/12',
    endDate: '2025/7/12',
    label: 'Birthday of Penang Governor (Penang Only)',
  },
  phSultan2025: {
    startDate: '2025/7/30',
    endDate: '2025/7/30',
    label: 'Birthday of Sultan Pahang (Pahang Only)',
  },
  mkGovBday2025: {
    startDate: '2025/8/24',
    endDate: '2025/8/24',
    label: 'Birthday of Malacca Governor (Malacca Only)',
  },
  mkGovBday2025replacement: {
    startDate: '2025/8/25',
    endDate: '2025/8/25',
    label: 'Birthday of Malacca Governor (Malacca Only) [Replacement]',
  },
  nationalDay2025: {
    startDate: '2025/8/31',
    endDate: '2025/8/31',
    label: 'National Day',
  },
  nationalDay2025replacement: {
    startDate: '2025/9/1',
    endDate: '2025/9/1',
    label: 'National Day [Replacement]',
  },
  malaysiaDay2025: {
    startDate: '2025/9/16',
    endDate: '2025/9/16',
    label: 'Malaysia Day',
  },
  deepavali2025: {
    startDate: '2025/10/20',
    endDate: '2025/10/20',
    label: 'Deepavali Day',
  },
  sultanPerak2025: {
    startDate: '2025/11/7',
    endDate: '2025/11/7',
    label: 'Birthday of Sultan Pahang (Pahang Only)',
  },
  sultanSelangor2025: {
    startDate: '2025/12/11',
    endDate: '2025/12/11',
    label: 'Birthday of Sultan Selangor (Selangor Only)',
  },
  christmas2025: {
    startDate: '2025/12/25',
    endDate: '2025/12/25',
    label: 'Christmas Day',
  },
}

export const publicHoliday2024 = {
  cny2024: {
    startDate: '2024/2/10',
    endDate: '2024/2/12',
    label: 'Chinese New Year',
  },
  cny2024replacement: {
    startDate: '2024/2/13',
    endDate: '2024/2/13',
    label: 'Chinese New Year [Replacement]',
  },
  jhrSultan2024: {
    startDate: '2024/3/23',
    endDate: '2024/3/23',
    label: 'Birthday of Sultan Johor (Johor Only)',
  },
  rayaAidilfitri2024: {
    startDate: '2024/4/10',
    endDate: '2024/4/10',
    label: 'Hari Raya Aidilfitri',
  },
  labour2024: {
    startDate: '2024/5/1',
    endDate: '2024/5/1',
    label: 'Labour Day',
  },
  agongBday2024: {
    startDate: '2024/6/3',
    endDate: '2024/6/3',
    label: 'Birthday of Yang Di-Pertuan Agong',
  },
  rayaHaji2024: {
    startDate: '2024/6/17',
    endDate: '2024/6/17',
    label: 'Hari Raya Haji',
  },
  sultanPahang2024: {
    startDate: '2024/7/30',
    endDate: '2024/7/30',
    label: 'Birthday of Sultan Pahang (Pahang Only)',
  },
  sultanMelaka2024: {
    startDate: '2024/8/24',
    endDate: '2024/8/24',
    label: 'Birthday of Malacca Governor (Melaka Only)',
  },
  nationalDay2024: {
    startDate: '2024/8/31',
    endDate: '2024/8/31',
    label: 'National Day',
  },
  malaysiaDay2024: {
    startDate: '2024/9/16',
    endDate: '2024/9/16',
    label: 'Malaysia Day',
  },
  deepavali2024: {
    startDate: '2024/10/31',
    endDate: '2024/10/31',
    label: 'Deepavali Day',
  },
  sultanSelangor2024: {
    startDate: '2024/12/11',
    endDate: '2024/12/11',
    label: 'Birthday of Sultan Selangor (Selangor Only)',
  },
  christmas2024: {
    startDate: '2024/12/25',
    endDate: '2024/12/25',
    label: 'Christmas Day',
  },
}

export const publicHoliday2023 = {
  cny2023: {
    startDate: '2023/1/22',
    endDate: '2023/1/24',
    label: 'Chinese New Year',
  },
  cny2023replacement: {
    startDate: '2023/1/25',
    endDate: '2023/1/25',
    label: 'Chinese New Year [Replacement]',
  },
  jhrSultan2023: {
    startDate: '2023/3/23',
    endDate: '2023/3/23',
    label: 'Birthday of Sultan Johor (Johor Only)',
  },
  rayaAidilfitri2023: {
    startDate: '2023/4/22',
    endDate: '2023/4/22',
    label: 'Hari Raya Aidilfitri',
  },
  labour2023: {
    startDate: '2023/5/1',
    endDate: '2023/5/1',
    label: 'Labour Day',
  },
  agongBday2023: {
    startDate: '2023/6/5',
    endDate: '2023/6/5',
    label: 'Birthday of Yang Di-Pertuan Agong',
  },
  rayaHaji2023: {
    startDate: '2023/6/29',
    endDate: '2023/6/29',
    label: 'Hari Raya Haji',
  },
  sultanPahang2023: {
    startDate: '2023/7/30',
    endDate: '2023/7/30',
    label: 'Birthday of Sultan Pahang (Pahang Only)',
  },
  sultanPahang2023Replacement: {
    startDate: '2023/7/31',
    endDate: '2023/7/31',
    label: 'Birthday of Sultan Pahang (Pahang Only) [Replacement]',
  },
  sultanMelaka2023: {
    startDate: '2023/8/24',
    endDate: '2023/8/24',
    label: 'Birthday of Malacca Governor (Melaka Only)',
  },
  nationalDay2023: {
    startDate: '2023/8/31',
    endDate: '2023/8/31',
    label: 'National Day',
  },
  malaysiaDay2023: {
    startDate: '2023/9/16',
    endDate: '2023/9/16',
    label: 'Malaysia Day',
  },
  deepavali2023: {
    startDate: '2023/11/12',
    endDate: '2023/11/12',
    label: 'Deepavali Day',
  },
  deepavali2023Replacement: {
    startDate: '2023/11/13',
    endDate: '2023/11/13',
    label: 'Deepavali Day [Replacement]',
  },
  sultanSelangor2023: {
    startDate: '2023/12/11',
    endDate: '2023/12/11',
    label: 'Birthday of Sultan Selangor (Selangor Only)',
  },
  christmas2023: {
    startDate: '2023/12/25',
    endDate: '2023/12/25',
    label: 'Christmas Day',
  },
}

export const publicHoliday2022 = {
  jhrSultan: {
    startDate: '2022/3/23',
    endDate: '2022/3/23',
    label: 'Birthday of Sultan Johor',
  },
  cny: {
    startDate: '2022/2/1',
    endDate: '2022/2/3',
    label: 'Chinese New Year',
  },
  labour: {
    startDate: '2022/5/1',
    endDate: '2022/5/1',
    label: 'Labour Day',
  },
  labourReplace: {
    startDate: '2022/5/2',
    endDate: '2022/5/2',
    label: 'Labour Day [Replacement]',
  },

  rayaPuasa: {
    startDate: '2022/5/3',
    endDate: '2022/5/3',
    label: 'Hari Raya Puasa',
  },
  agongBday: {
    startDate: '2022/6/6',
    endDate: '2022/6/6',
    label: 'Birthday of Yang Di-Pertuan Agong',
  },
  rayaHaji: {
    startDate: '2022/7/10',
    endDate: '2022/7/10',
    label: 'Hari Raya Haji',
  },
  rayaHajiReplace: {
    startDate: '2022/7/11',
    endDate: '2022/7/11',
    label: 'Hari Raya Haji [Replacement]',
  },
  sultanPahang: {
    startDate: '2022/7/30',
    endDate: '2022/7/30',
    label: 'Birthday of Sultan Pahang (Pahang Only)',
  },
  sultanMelaka: {
    startDate: '2022/8/24',
    endDate: '2022/8/24',
    label: 'Birthday of Malacca Governor (Melaka Only)',
  },
  nationalDay: {
    startDate: '2022/8/31',
    endDate: '2022/8/31',
    label: 'National Day',
  },
  malaysiaDay: {
    startDate: '2022/9/16',
    endDate: '2022/9/16',
    label: 'Malaysia Day',
  },
  deepavali: {
    startDate: '2022/10/24',
    endDate: '2022/10/24',
    label: 'Deepavali Day',
  },
  sultanSelangor: {
    startDate: '2022/12/11',
    endDate: '2022/12/11',
    label: 'Birthday of Sultan Selangor (Selangor Only)',
  },
  sultanSelangorReplace: {
    startDate: '2022/12/12',
    endDate: '2022/12/12',
    label: 'Birthday of Sultan Selangor (Selangor Only) [Replacement]',
  },
  christmas: {
    startDate: '2022/12/25',
    endDate: '2022/12/25',
    label: 'Christmas Day',
  },
  christmasReplace: {
    startDate: '2022/12/26',
    endDate: '2022/12/26',
    label: 'Christmas Day [Replacement]',
  },
}
